

































import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import { uri } from "@/config/map/map.config.json";
import { LPopup, LGeoJson } from "vue2-leaflet";
import { LMap, LTileLayer, LMarker, LCircle } from "vue2-leaflet";
import { Icon } from "leaflet";
import { Geometry } from "@/@types/wiki/geojson";
import { GeoJSON } from "geojson";

import GPSDotsModul from "@/modules/_mixins/wiki/gps-dots-modul";
import L from "leaflet";
import Vue2LeafletMarkerCluster from "vue2-leaflet-markercluster";
import StandartModal from "@/components/app/standart-modal.vue";

type D = Icon.Default & {
  _getIconUrl?: string;
};
delete (Icon.Default.prototype as D)._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

@Component({
  name: "MarkerMap",
  components: {
    StandartModal,
    "l-map": LMap,
    "l-tile-layer": LTileLayer,
    "l-marker": LMarker,
    "l-circle": LCircle,
    "v-marker-cluster": Vue2LeafletMarkerCluster,
    "l-popup": LPopup,
    LGeoJson,
  },
})
export default class ChangeExcursionMarker extends Mixins(GPSDotsModul) {
  @Prop({ type: Object, default: null }) location!: Geometry;

  circleDots: L.Circle[] = [];
  show = false;

  url = uri;
  attribution =
    '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors';
  zoom = 11;

  center = [55, 37];
  markerLatLng: number[] | null = null;

  map!: L.Map;

  $refs!: {
    map: LMap;
  };

  get geojson(): GeoJSON {
    return {
      type: "FeatureCollection",
      features: [
        {
          type: "Feature",
          geometry: this.location,
          properties: {},
        },
      ],
    };
  }

  get markers(): Array<Array<number>> {
    if (
      !this.location ||
      !this.location.coordinates.length ||
      !this.location.radius
    )
      return [];
    if (this.location.type == "Point") return [this.location.coordinates];
    if (
      this.location.type == "MultiPoint" ||
      this.location.type == "LineString"
    )
      return this.location.coordinates;
    return [];
  }

  getShipCoords(): void {
    this.updateCoords().then(() => {
      this.center = [this.latitude, this.longitude];
      localStorage.setItem(
        "ExcursionCenter",
        `${this.latitude}$${this.longitude}`
      );
    });
  }

  @Watch("location", { deep: true })
  updateCenter(): void {
    if (this.location.type == "Point")
      this.center = [
        this.location.coordinates[1],
        this.location.coordinates[0],
      ];
    if (
      this.location.type == "MultiPoint" ||
      this.location.type == "LineString"
    )
      this.center = [
        this.location.coordinates[this.location.coordinates.length - 1][1],
        this.location.coordinates[this.location.coordinates.length - 1][0],
      ];
  }

  addMarker(): void {
    this.map.on("click", (event) => {
      let lat_lon = event.latlng
        .toString()
        .substring(7, event.latlng.toString().length - 1);
      const lat = Number(lat_lon.slice(0, lat_lon.indexOf(",")));
      const lon = Number(
        lat_lon.slice(lat_lon.indexOf(",") + 2, lat_lon.length - 1)
      );
      this.markerLatLng = [lat, lon];
      localStorage.setItem("ExcursionCenter", `${lat}$${lon}`);
      this.$emit("changeCoordinats", [
        lon != 0 ? lon : 0.00001,
        lat != 0 ? lat : 0.00001,
      ]);
    });
  }

  openmap(): void {
    setTimeout(() => {
      this.show = true;
      setTimeout(() => {
        this.map = this.$refs.map.mapObject;
        this.$nextTick(() => {
          this.map.attributionControl.setPrefix("Filoxenia");
        });
        this.addMarker();

        const center = localStorage.getItem("ExcursionCenter");
        if (!center) return;
        const delimiter = center.indexOf("$");
        const lat = center.substr(0, delimiter - 1);
        const lon = center.substr(delimiter + 1, center.length - 1);
        this.center = [Number.parseFloat(lat), Number.parseFloat(lon)];
        this.updateCenter();
      }, 0);
    }, 0);
  }
}
